import * as React from "react";
import type { SVGProps } from "react";
const SvgStatsMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#23F6E7"
      d="M10.08 2a2 2 0 0 1 1.457.63l1.92 2.043A2 2 0 0 1 14 6.043v8.312a.67.67 0 0 1-.178.456.6.6 0 0 1-.429.189H3.607a.6.6 0 0 1-.428-.19.67.67 0 0 1-.179-.455V2.645C3 2.289 3.272 2 3.607 2z"
      opacity={0.8}
    />
    <path
      fill="#7492FF"
      d="M7.889 11.75v-6.5H9.11v6.5zM10.333 11.75v-3.9h1.222v3.9zM5.444 11.75v-2.6h1.223v2.6z"
    />
  </svg>
);
export default SvgStatsMain;
